import { Button, Post } from '@asset-metrix/portal-ui';

import { FullScreenFrame } from '../components/fullscreenframe/FullScreenFrame';
import { useStore } from '../store';

const TenantNotFound = () => {
  const tenantName = useStore((state) => state.tenantName);

  return (
    <FullScreenFrame>
      <Post>
        <h1>Tenant not found</h1>
        <p>
          The requested tenant <b>{tenantName}</b> is not available. Did you
          misspell it?
        </p>
        <p data-right>
          <Button onClick={() => globalThis.location.reload()}>
            Refresh the page
          </Button>
        </p>
      </Post>
    </FullScreenFrame>
  );
};

const TenantLoading = () => {
  return (
    <FullScreenFrame loading>
      <Post>
        <h1>Loading tenant theme</h1>
      </Post>
    </FullScreenFrame>
  );
};

export const TenantPreLoader = ({ isError }: { isError: boolean }) => {
  return isError ? <TenantNotFound /> : <TenantLoading />;
};
